// Evento global para manter o saldo de créditos exibido fora do chat (menu da conta na
// sidebar) em sincronia com o que o chat acabou de descobrir — antes o menu buscava o saldo
// uma única vez ao montar e ficava desatualizado depois de cada mensagem.
export const CREDITS_UPDATED_EVENT = 'credits:updated';

/** detail: { available?: number, plan?: string | null } */
export function emitCreditsUpdated(detail) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(CREDITS_UPDATED_EVENT, { detail }));
}
